import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
import { Formik, useFormikContext } from 'formik';
import { ComputeEntitySelector } from 'modules/Compute/Components/ComputeEntitySelector/ComputeEntitySelector';
import { formatPricingPerHour } from 'utils/pricing';
import { ModelPricing } from 'components/Pricing/ModelPricing';
import { SelectOption } from 'components/ui_library/Formik/components/FormElements/Select';
import { PlaygroundChatConfigSidebar } from './PlaygroundChatConfigSidebar';
import SvgXCloseMd from './Icons/XCloseMd';
import { PlaygroundConfig } from '../types/playgroundConfig';
export interface MobileSidebarHandle {
  openDialog: () => unknown;
  closeDialog: () => unknown;
}
interface PlaygroundChatMobileConfigSidebarProps {
  deploymentOptions: SelectOption[];
}
export const PlaygroundChatMobileConfigSidebar = forwardRef<MobileSidebarHandle, PlaygroundChatMobileConfigSidebarProps>(({
  deploymentOptions
}, ref) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [, setIsOpen] = useState(false);
  const {
    values,
    setFieldValue
  } = useFormikContext<PlaygroundConfig>();
  useImperativeHandle(ref, () => ({
    openDialog,
    closeDialog
  }));
  const modelVersionId = values.modelVersion?.id ?? values.model?.model_version?.id ?? undefined;
  const handleDeploymentChange = (selectedDeploymentId: string, option: Record<string, unknown>) => {
    setFieldValue('deploymentId', selectedDeploymentId);
    const {
      rawData
    } = (option as Record<'rawData', CF.API.Compute.Deployment>);
    const price = rawData?.nodepools?.map(nodepool => nodepool.instance_types?.map(instanceType => instanceType.price)).flat()?.[0];
    setFieldValue('deploymentPrice', price !== undefined ? `$ ${formatPricingPerHour(Number(price ?? 0))} / h / instance` : null);
  };
  const openDialog = () => {
    if (dialogRef?.current) {
      dialogRef.current.show();
      setIsOpen(true);
    }
  };
  const closeDialog = () => {
    if (dialogRef?.current) {
      dialogRef.current.close();
      setIsOpen(false);
    }
  };
  return <dialog className={dialogContainer} ref={dialogRef}>
        <div className={sidebarHeader}>
          Settings
          {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events */}
          <div role="button" onClick={closeDialog} className={SidebarCloseButton}>
            <SvgXCloseMd />
          </div>
        </div>
        <div className={sidebarComputeSelector}>
          <span className={computeLabel}>Compute</span>
          <Formik initialValues={{}} onSubmit={() => {}}>
            {modelVersionId && <ComputeEntitySelector className={PlaygroundDeploySelector} data-testid="deploy-cluster-id" entityType="deployment" name="deploymentId" onSelect={handleDeploymentChange} options={deploymentOptions} />}
          </Formik>
          {values.model && <ModelPricing model={((values.model as unknown) as CF.API.Models.Model)} />}
        </div>
        <PlaygroundChatConfigSidebar className={ConfigStyle} />
      </dialog>;
});
const ConfigStyle = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-ConfigStyle-cbptpoe";
const sidebarComputeSelector = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-sidebarComputeSelector-s1pl3bbb";
const computeLabel = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-computeLabel-cb6xncu";
const dialogContainer = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-dialogContainer-dhglu2z";
const sidebarHeader = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-sidebarHeader-s1vfe4bd";
const SidebarCloseButton = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-SidebarCloseButton-sip2qfs";
const PlaygroundDeploySelector = "odules__Playground__Components__PlaygroundChatMobileConfigSidebar_tsx-PlaygroundDeploySelector-p1wjpo42";

require("./PlaygroundChatMobileConfigSidebar.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PlaygroundChatMobileConfigSidebar.tsx");